import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { MyFooter } from '../components/myfooter/footer.components'
import Navbar1 from '../components/mynavbar/navbar1.components'
import { scrollToContactSection, scrollToPageTop } from '../utils/scroll.utils'
import './other-styles.styles.scss'

const NavigationPage = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash === '#contact') {
      const timer = window.setTimeout(() => {
        scrollToContactSection()
      }, 80)
      return () => window.clearTimeout(timer)
    }

    scrollToPageTop()
    return undefined
  }, [location.pathname, location.hash, location.key])

  return (
    <>
      <div className="navbar">
        <Navbar1 />
      </div>

      <div className="main-container">
        <Outlet />
      </div>

      <div className="footer-joined">
        <MyFooter />
      </div>
    </>
  )
}

export default NavigationPage
